<template>
  <div class="content-wrapper">
    <router-view />
  </div>
</template>
<script lang="ts" src="./script.ts"></script>
<style lang="scss" src="./style.scss" scoped></style>
